import React, { Component } from 'react';
import moment from 'moment';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Progress from 'reactstrap/lib/Progress';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import { Auth } from '../../../../../actions/Auth';

import { PersonalDetails } from './personal-details';
import Button from '../../../../global/Button';
import { CVPreview } from '../../../cv-builder/cv-preview';
import { InputField } from '../../../../global/Forms';
import { Select } from '../../../../global/Forms/Select';
import { SingleDatePicker } from '../../../../global/Forms/DatePicker';
import { HorizontalLine } from '../../../../global/horizontal_line';
import { CONSTANTS } from '../../../../../constants';
import { Academics } from './academics';
import { Loader } from '../../../../global/Loader';
import { ProfessionalExperience } from './professional-exp';
import { Projects } from './projects';
import { Achievements } from './achievements';
import { OtherExperience } from './other-exp';
import { Skills } from './skills';
import { POR } from './por';
import { ExtraCurricular } from './extra-curricular';
import FreezeProfile from './FreezeProfile.js';
import { getQueryParams } from '../../../../../actions';
import store from '../../../../../store';

export class BuildProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sideNavLeft: null,
      sideNavRight: null,
      cvPreview: false,
      editableSection: "",
      currentTab: 1,
      originalData: null,
      commentThreads: [],
      loading: false,
      backlogData: null,
      ptNotes: [],
      showPtNoteModal: false,
      ptNoteForm: { type: "", note_type: "", note_date: "", points: "", comment: "" },
      deletePtNoteId: null,
      hoveredPtNoteId: null
    }
  }

  toggleLoading = loading => {
    this.setState({
      loading
    })
  }

  componentDidMount() {
    this.getCommentThreads();
    this.backlogCount();
    this.getPtNotes();
    var fixedSideNavStyle = {
      left: "",
      width: ""
    }
    var leftSideNavCol = document.querySelector(".left-sidenav").getBoundingClientRect();
    fixedSideNavStyle = {
      left: leftSideNavCol.left,
      width: leftSideNavCol.width,
      minWidth: leftSideNavCol.width <= 145 ? 250: 150,
      zIndex: 2,
      display : leftSideNavCol.width <= 145 ? "none" : "block",
      _isShowMenu : leftSideNavCol.width <= 145,
    }
    this.setState({
      sideNavLeft: fixedSideNavStyle
    })
    var rightSideNavCol = document.querySelector(".right-sidenav").getBoundingClientRect();
    fixedSideNavStyle = {
      left: rightSideNavCol.left,
      width: rightSideNavCol.width
    }
    this.setState({ sideNavRight: fixedSideNavStyle })
  }



  getCommentThreads = async () => {
    var studentId = this.props.studentDetails.user_info.student_id;
    try {
      let resp = await Auth.CommentBox.getCommentThread(studentId);
      this.setState({ commentThreads: resp.data })
    } catch (e) {
      console.log(e)
    }
  }

  backlogCount = async () => {
    var studentId = this.props.studentDetails.user_info.student_id;
    try {
      let resp = await Auth.Student.getBacklogCount(studentId);
      this.setState({backlogData: resp.data[0]})
    } catch (e) {
      console.log(e)
    }
  }

  getPtNotes = async () => {
    var studentId = this.props.studentDetails.user_info.student_id;
    try {
      let resp = await Auth.Student.getPtNotes(studentId);
      this.setState({ ptNotes: resp.data })
    } catch (e) {
      console.log(e)
    }
  }

  togglePtNoteModal = show => {
    this.setState({
      showPtNoteModal: show,
      ptNoteForm: { type: "", note_type: "", note_date: "", points: "", comment: "" }
    })
  }

  changePtNoteForm = e => {
    let { ptNoteForm } = this.state;
    ptNoteForm[e.target.name] = e.target.value;
    if (e.target.name === "type" && e.target.value !== "PENALTY") {
      ptNoteForm.note_type = "";
    }
    this.setState({ ptNoteForm })
  }

  changePtNoteDate = mDate => {
    let { ptNoteForm } = this.state;
    ptNoteForm.note_date = mDate ? mDate.format("YYYY-MM-DD") : "";
    this.setState({ ptNoteForm })
  }

  addPtNote = async () => {
    let { ptNoteForm } = this.state;
    if (!ptNoteForm.type || !ptNoteForm.note_date || ptNoteForm.points === "") return;
    if (ptNoteForm.type === "PENALTY" && !ptNoteForm.note_type) return;
    try {
      var studentId = this.props.studentDetails.user_info.student_id;
      await Auth.Student.createPtNote({
        student_id: studentId,
        type: ptNoteForm.type,
        note_type: ptNoteForm.type === "PENALTY" ? ptNoteForm.note_type : undefined,
        note_date: ptNoteForm.note_date,
        points: ptNoteForm.points,
        comment: ptNoteForm.comment
      });
      this.togglePtNoteModal(false);
      await this.getPtNotes();
    } catch (e) {
      console.log(e)
    }
  }

  confirmDeletePtNote = pt_note_id => {
    this.setState({ deletePtNoteId: pt_note_id })
  }

  deletePtNote = async () => {
    try {
      var studentId = this.props.studentDetails.user_info.student_id;
      await Auth.Student.deletePtNote({
        pt_note_id: this.state.deletePtNoteId,
        student_id: studentId
      });
      this.setState({ deletePtNoteId: null });
      await this.getPtNotes();
    } catch (e) {
      console.log(e)
    }
  }

  onCancel = () => {
    this.toggleSection("");
    let { originalData } = this.state;
    if (originalData) {
      originalData.personal_info.hobbies = this.props.studentDetails.personal_info.hobbies;
      this.props.updateStudentDetails(originalData);
      this.setState({
        originalData: null
      })
    }
  }

  toggleSection = section => {
    let { editableSection, originalData } = this.state;
    if (section && editableSection !== section) {
      originalData = JSON.parse(JSON.stringify(this.props.studentDetails))
    }
    this.setState({
      editableSection: editableSection !== section ? section : "",
      originalData
    })
    return false;
  }

  toggleCV = () => {
    if (!this.state.cvPreview)
      this.props.generateCVConfig()
    this.setState({
      cvPreview: !this.state.cvPreview
    })
  }

  requiredValidation = fields => {
    let validFields = fields.filter(field => {
      if (Array.isArray(field)) {
        if (field.length > 0) {
          return true
        }
      } else {
        if (field) {
          return true
        }
      }
      return false
    })
    return validFields.length > 0 ? true : false
  }

  changeTab = (e) => {
    let tab = e.target.dataset.tabid;
    let baseUrl = this.props.isPT ? "/pt/students/recruitments/" + this.props.match.params.student_id + "/profile/" : "/student/recruitments/profile/"
    this.props.history.push(baseUrl + tab + window.location.search)
    this.setState({
      editableSection: "",
      sideNavLeft: this.state.sideNavLeft._isShowMenu ? { ...this.state.sideNavLeft, display: "none" } : this.state.sideNavLeft
    })
    window.scrollTo(0, 0)
  }

  getStudentProfile = async () => {
    this.setState({ originalData: null })
    await this.props.getStudentProfile()
  }

  redirectToStudent = async(user_info) => {
    let {history} = this.props,
    {role, user} = store.getState(),
    campusId = role.instituteDetail.campus_id,
    {process_id} = getQueryParams(window.location.search),
    verifierRole = user.roles.filter(r=>(r.role_type==="VERIFIER" && r.instituteDetail.campus_id===campusId))
    if(verifierRole.length>0 && process_id) {
      let el = document.getElementById(`role-${verifierRole[0].assigned_role_id}`)
      if(el) {
        await el.click()
        history.push(`/verifier/verification/${user_info.student_id}/${process_id}/studentDetails`)
      }
    }
  }

  render() {
    let { studentDetails, studentCVDetails, settings, config, roleList, domainList, boardList, degreeList, industryList, sectorList, tab } = this.props,
      { cvPreview, editableSection, currentTab, loading, sideNavLeft, sideNavRight, commentThreads, ptNotes, showPtNoteModal, ptNoteForm, deletePtNoteId, hoveredPtNoteId } = this.state,
      { files, cv_point, extra_curricular_activity, position_of_responsibility, personal_info, user_info, preferences, academic_detail, professional_detail, project, achievement, other_experience, skill } = studentDetails,
      sections = [],
      profileProps = {
        getStudentProfile: this.getStudentProfile,
        editableSection,
        files,
        commentThreads,
        toggleLoading: this.toggleLoading,
        toggleSection: this.toggleSection,
        requiredValidation: this.requiredValidation,
        changeCVPoint: this.props.changeCVPoint,
        onCancel: this.onCancel,
        cv_point,
        user_info,
        role: this.props.role
      },
      progress = studentDetails.profile_metric.profile_completion_percentage,
      ptNoteSummary = Object.keys(CONSTANTS.PT_NOTE_MAIN_TYPES).map(type => ({
        type,
        label: CONSTANTS.PT_NOTE_MAIN_TYPES[type],
        sum: ptNotes.filter(note => note.type === type).reduce((total, note) => total + parseInt(note.points || 0, 10), 0)
      })).filter(item => item.sum !== 0);
    if (config) {
      sections = Object.keys(config.section_order).sort().map(order => {
        return config.section_order[order]
      })
    }
    let hasPermission = this.props.role.hasPermission;
    let allowPTEdit = hasPermission.editStudent && hasPermission.editStudent && hasPermission.editStudent.permission_access && hasPermission.editStudent.permission_access.read === 1 ? true : false;
    // if(settings.STUDENT && settings.STUDENT.PROFILE) 
    //   if(settings.STUDENT.PROFILE.allow_pt_edit===1)
    var studentInfo = studentDetails.student_info[0] || {};
    return (
      <Container>
        <Row className="m-column">
          <Col xs={3} className="left-sidenav">
            <div className="r-sidenav r-sidenav-fixed" style={{...sideNavLeft}} id="sidenav" >
              <div className="r-sidenav__header">
                <Row className="align-items-center">
                  <Col><h1 className="r-heading-4 d-inline-block mb-0">Build Profile</h1></Col>
                  {(settings.STUDENT.STUDENT_CV_SETTING[studentInfo.batch_id] && settings.STUDENT.STUDENT_CV_SETTING[studentInfo.batch_id].cv_builder===1)&&<Col className="pb-2 pt-1"><Button onClick={this.toggleCV} color="grey r-text--light r-text--sm float-right r-bg--grey-4"><i className="mr-3 fi flaticon-portfolio"></i>Resume Preview</Button></Col>}
                </Row>
                <div className="d-flex r-text--dark r-subheading-4 mt-3">
                  <span>{progress}% Complete</span>
                </div>
                <Progress value={progress} color={progress < 40 ? "danger" : (progress < 80 ? "warning" : "success")} className="r-progress" />
              </div>
              <ul className="r-sidenav__menu">
                {
                  CONSTANTS.SIDENAV.map(nav => {
                    return (
                      <li key={nav.id} onClick={this.changeTab} data-tabid={nav.id} className={"r-heading-6 " + (tab === nav.id ? "sidenav-active" : "")}>
                        {nav.text}
                      </li>
                    )
                  })
                }
              </ul>
            </div>
          </Col>
          <Col xs={12} md={7}>
            <Loader show={loading} />
            {!!sideNavLeft && sideNavLeft._isShowMenu && 
            <div onClick={() => {sideNavLeft.display = sideNavLeft.display === "none" ? "block" : "none"; this.setState({sideNavLeft})}} style={{width: 32, height: 32, left: sideNavLeft.display === "block" ? sideNavLeft.minWidth - 32 : "-5px", top: 0, zIndex: 99, background: "#b1d0ef", color: "#06c", padding: "1px 0 0 8px", fontSize: 20, borderRadius: 5}} className="position-absolute selectable">
              <span className={"fi "+ (sideNavLeft.display === "block" ? "flaticon-close" : "flaticon-arrow")}></span>
            </div>
            }
            <div className={'student__profile' + ((user_info.freeze_status || (this.props.isPT && !allowPTEdit)) ? ' student__profile--noedit' : ' ')} >

              {tab === "personal" && <PersonalDetails
                {...profileProps}
                changeProfile={this.props.changeProfile}
                personal_info={personal_info}
                preferences={preferences}
                toggleCV={this.toggleCV}
                changePreferences={this.props.changePreferences}
                roleList={roleList}
                domainList={domainList}
                settings={settings} />}
              {
                tab === "academic" && <Academics
                  {...profileProps}
                  changeAcademics={this.props.changeAcademics}
                  toggleCV={this.toggleCV}
                  academic_detail={academic_detail}
                  boardList={boardList}
                  settings={settings}
                  degreeList={degreeList} />
              }
              {
                tab === "responsibility" && <POR
                  {...profileProps}
                  changePorDetail={this.props.changePorDetail}
                  toggleCV={this.toggleCV}
                  settings={settings}
                  position_of_responsibility={position_of_responsibility} />
              }
              {
                tab === "professional" && <ProfessionalExperience
                  {...profileProps}
                  changeProDetail={this.props.changeProDetail}
                  toggleCV={this.toggleCV}
                  professional_detail={professional_detail}
                  sectorList={sectorList}
                  settings={settings}
                  industryList={industryList} />
              }
              {
                tab === "project" && <Projects
                  {...profileProps}
                  changeProjectDetail={this.props.changeProjectDetail}
                  toggleCV={this.toggleCV}
                  project={project}
                  sectorList={sectorList}
                  settings={settings}
                  industryList={industryList} />
              }
              {
                tab === "extracurricular" && <ExtraCurricular
                  {...profileProps}
                  extra_curricular_activity={extra_curricular_activity}
                  toggleCV={this.toggleCV}
                  settings={settings}
                  changeExtraCurricular={this.props.changeExtraCurricular} />
              }
              {
                tab === "achievement" && <Achievements
                  {...profileProps}
                  toggleCV={this.toggleCV}
                  settings={settings}
                  changeAchievement={this.props.changeAchievement}
                  achievement={achievement} />
              }
              {
                tab === "other" && <OtherExperience
                  {...profileProps}
                  toggleCV={this.toggleCV}
                  settings={settings}
                  changeOtherExp={this.props.changeOtherExp}
                  other_experience={other_experience} />
              }
              {
                tab === "skill" && <Skills
                  {...profileProps}
                  toggleCV={this.toggleCV}
                  settings={settings}
                  changeSkill={this.props.changeSkill}
                  skill={skill} />
              }
            </div>
            <aside className="student__cv">
              <Modal modalClassName="student__cv__preview" isOpen={cvPreview} toggle={this.toggleCV}>
                <Button className="fi flaticon-plus-1 p-3 r-text--lg" style={{position:"absolute",zIndex:100}} onClick={this.toggleCV}></Button>
                <CVPreview showUnverified={true} preview={true} sections={sections} data={studentCVDetails} config={config} />
              </Modal>
            </aside>
          </Col>
          <Col xs={10} md={2} className="right-sidenav px-0">
            <div className="r-sidenav-fixed" style={{ ...sideNavRight }} >
              <Row className="justify-content-between align-items-center px-0 py-2">
                <Col xs="auto" >
                  <span className="r-heading-4 d-inline-block mb-0  r-text--blue-3 selectable" onClick={()=>this.redirectToStudent(user_info)}> Verification</span>
                </Col>
                <Col xs="auto" className="mt-2">
                  <span>{studentDetails.profile_metric.unverified_point + studentDetails.profile_metric.verified_point + studentDetails.profile_metric.rejected_point} Points</span>
                </Col>
              </Row>
              <HorizontalLine color="#cfcfcf" />
              <Row noGutters className="text-center px-0 py-3">
                <Col xs="4" style={{ fontSize: "12px" }}>
                  <Row className="justify-content-center align-items-center">
                    <span className="mr-1">{studentDetails.profile_metric.unverified_point}</span>
                    <div style={{ width: "10px", height: "10px", borderRadius: "5px", textAlign: "center", backgroundColor: "#fc3" }} />
                  </Row>
                  <span>Pending</span>
                </Col>
                <Col xs="4" style={{ fontSize: "12px" }}>
                  <Row className="justify-content-center align-items-center">
                    <span className="mr-1">{studentDetails.profile_metric.verified_point}</span>
                    <div style={{ width: "10px", height: "10px", borderRadius: "5px", textAlign: "center", backgroundColor: "green" }} />
                  </Row>
                  <span>Approved</span>
                </Col>
                <Col xs="4" style={{ fontSize: "12px" }}>
                  <Row className="justify-content-center align-items-center">
                    <span className="mr-1">{studentDetails.profile_metric.rejected_point}</span>
                    <div style={{ width: "10px", height: "10px", borderRadius: "5px", textAlign: "center", backgroundColor: "red" }} />
                  </Row>
                  <span>Rejected</span>
                </Col>
              </Row>

              <Row className="justify-content-between align-items-center px-0 py-2 mt-2">
                <Col xs="auto">
                  <span className="r-heading-4 d-inline-block mb-0 r-text--blue-3">PT Notes</span>
                </Col>
                {this.props.isPT &&
                <Col xs="auto">
                  <Button className="r-text--sm fi flaticon-plus" color="link" onClick={() => this.togglePtNoteModal(true)}></Button>
                </Col>}
              </Row>
              <HorizontalLine color="#cfcfcf" />
              {ptNoteSummary.length > 0 &&
              <Row noGutters className="px-0 pt-3">
                {ptNoteSummary.map(item => (
                  <Col xs="auto" key={item.type} className="text-center mr-2 mb-2 px-3 py-2 r-bg--grey-1 rounded">
                    <div className="r-subheading-3 mb-0">{item.sum}</div>
                    <span className="r-text--grey-4" style={{ fontSize: "11px" }}>{item.label}</span>
                  </Col>
                ))}
              </Row>}
              <div className="px-0 pb-2">
                {ptNotes.length > 0 ? ptNotes.map(note => (
                  <div
                    key={note.pt_note_id}
                    className="py-2 borderBottomlightblack"
                    onMouseEnter={() => this.setState({ hoveredPtNoteId: note.pt_note_id })}
                    onMouseLeave={() => this.setState({ hoveredPtNoteId: null })}
                  >
                    <Row className="justify-content-between align-items-center mx-0">
                      <span className="r-subheading-4 mb-0">{note.note_type ? (CONSTANTS.PT_NOTE_REASON_TYPES[note.note_type] || note.note_type) : (CONSTANTS.PT_NOTE_MAIN_TYPES[note.type] || note.type)}</span>
                      <span className="r-subheading-4 mb-0">
                        {note.points}
                        {note.comment && <i className="fi flaticon-comment ml-2 r-text--grey-4" title={note.comment}></i>}
                        {this.props.isPT && hoveredPtNoteId === note.pt_note_id &&
                        <i className="fi flaticon-bin selectable ml-2 r-text--grey-4" onClick={() => this.confirmDeletePtNote(note.pt_note_id)}></i>}
                      </span>
                    </Row>
                    <Row className="justify-content-between align-items-center mx-0 mt-1">
                      <span className="r-text--grey-4" style={{ fontSize: "11px" }}>{CONSTANTS.PT_NOTE_MAIN_TYPES[note.type] || note.type}</span>
                      {note.note_date && <span className="r-text--grey-4" style={{ fontSize: "11px" }}>{moment(note.note_date).format("DD MMM YYYY")}</span>}
                    </Row>
                  </div>
                )) : <span className="r-text--sm r-text--grey-4">No PT notes added</span>}
              </div>

              {(studentDetails.user_info.freeze_status===0)?<FreezeProfile studentDetails={studentDetails} />:
              <Col xs={12} className="r-bg--brandB rounded">
                <span className="mr-1">Your Profile is freezed</span>
              </Col>}


              {!!this.state.backlogData &&
              <>
              <Row>
                <Col xs="12" className="mt-3 mb-2">
                <span className="r-heading-4 d-inline-block mb-0  r-text--blue-3 " > Backlogs</span>
                </Col>
              </Row>
              <HorizontalLine color="#cfcfcf" />
              <Row noGutters className="text-center px-0 py-3">
                  <Col xs="12" md="4" style={{ fontSize: "12px" }}>
                    <Row className="justify-content-center align-items-center">
                      <span className="mr-1">{this.state.backlogData && this.state.backlogData.backlog_count ? this.state.backlogData.backlog_count : 0}</span>
                    </Row>
                    <span>Total</span>
                  </Col>
                  <Col xs="12" md="4" style={{ fontSize: "12px" }}>
                    <Row className="justify-content-center align-items-center">
                      <span className="mr-1">{this.state.backlogData && this.state.backlogData.current_backlog_count ? this.state.backlogData.current_backlog_count : 0}</span>
                    </Row>
                    <span>Current</span>
                  </Col>
              </Row>
              </>
              }

              <Modal centered isOpen={showPtNoteModal} toggle={() => this.togglePtNoteModal(false)}>
                <ModalBody>
                  <h3 className="r-heading-4 mb-3">Add PT Note</h3>
                  <Row className="mb-2">
                    <Col xs={12}>
                      <label className="r-text--sm d-block">Type</label>
                      <Select name="type" value={ptNoteForm.type} onChange={this.changePtNoteForm}>
                        <option value="">Select Type</option>
                        {Object.keys(CONSTANTS.PT_NOTE_MAIN_TYPES).map(type => <option key={type} value={type}>{CONSTANTS.PT_NOTE_MAIN_TYPES[type]}</option>)}
                      </Select>
                    </Col>
                  </Row>
                  {ptNoteForm.type === "PENALTY" &&
                  <Row className="mb-2">
                    <Col xs={12}>
                      <label className="r-text--sm d-block">Reason</label>
                      <Select name="note_type" value={ptNoteForm.note_type} onChange={this.changePtNoteForm}>
                        <option value="">Select Reason</option>
                        {Object.keys(CONSTANTS.PT_NOTE_REASON_TYPES).map(type => <option key={type} value={type}>{CONSTANTS.PT_NOTE_REASON_TYPES[type]}</option>)}
                      </Select>
                    </Col>
                  </Row>}
                  <Row className="mb-2">
                    <Col xs={12}>
                      <label className="r-text--sm d-block">Date</label>
                      <SingleDatePicker
                        value={ptNoteForm.note_date ? moment(ptNoteForm.note_date) : ""}
                        onDateChange={this.changePtNoteDate}
                        pickerProps={{ isOutsideRange: day => day.isAfter(moment(), "day") }}
                      />
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    <Col xs={12}>
                      <label className="r-text--sm d-block">Points</label>
                      <InputField className="w-100" type="number" name="points" value={ptNoteForm.points} onChange={this.changePtNoteForm} />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col xs={12}>
                      <label className="r-text--sm d-block">Comment</label>
                      <textarea className="r-inputfield w-100" rows="3" name="comment" value={ptNoteForm.comment} onChange={this.changePtNoteForm}></textarea>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-right">
                      <Button onClick={() => this.togglePtNoteModal(false)} className="mr-2 r-btn r-btn--outline-dark-v r-text--sm">Cancel</Button>
                      <Button className="r-btn r-btn--dark r-text--sm" onClick={this.addPtNote}>Save</Button>
                    </Col>
                  </Row>
                </ModalBody>
              </Modal>

              <Modal centered size="sm" isOpen={!!deletePtNoteId} toggle={() => this.setState({ deletePtNoteId: null })}>
                <ModalBody>
                  <h3>Are you Sure ?</h3>
                  <Row className="mt-3">
                    <Col className="text-right">
                      <Button onClick={() => this.setState({ deletePtNoteId: null })} className="mr-2 r-btn r-btn--outline-dark-v r-text--sm">Cancel</Button>
                      <Button className="r-btn r-btn--dark r-text--sm" onClick={this.deletePtNote}>Sure</Button>
                    </Col>
                  </Row>
                </ModalBody>
              </Modal>
            </div>
            {/* <div className="student__documents card r-sidenav-fixed" style={{ ...sideNavRight }} >

              <div className="card-header pt-4 r-bg--light">
                <h1 className="r-subheading-2 r-text--blue-3 float-left mt-2">Documents</h1>
                <div className="student__profile__actions mt-4 mr-2">
                  <Button className="r-text--sm student__profile__actions--add float-right fi flaticon-plus" color="brandB"><span >Add</span></Button>
                </div>

              </div>
              <div className="text-middle p-3 pb-0">
                <InputField className="w-100 r-radius--3 pr-5" placeholder="Search" />
                <i style={{ position: 'absolute', marginLeft: '-20px' }} className="pt-2 mt-1  r-text--grey-4 fi flaticon-search "></i>
              </div>
              <div className="card-body p-2 pt-0">
                <ul className="student__documents__list">
                  <li draggable><span>My Document 001</span></li>
                  <li draggable><span>My Document 002</span></li>
                  <li draggable><span>My Document 003</span></li>
                  <li draggable><span>My Document 004</span></li>
                  <li draggable><span>My Document 005</span></li>
                  <li draggable><span>My Document 006</span></li>
                  <li draggable><span>My Document 007</span></li>
                  <li draggable><span>My Document 008</span></li>
                  <li draggable><span>My Document 009</span></li>
                  <li draggable><span>My Document 010</span></li>
                  <li draggable><span>My Document 011</span></li>

                </ul>
              </div>
              <div className="card-footer text-muted p-1 r-bg--light">
                <Button className="r-text--sm" color="link-blue">View in file manager</Button>
                <em className="r-text--sm">Documents are directly saved into your File Manager.</em>
              </div>
            </div> */}
          </Col>
        </Row>
      </Container>
    )
  }
}
